import DbService from 'resources/db.service';
import uiNotificationService from 'services/uiNotification.service';
import schema from './listedkit.schema';
import { getDefaultKitTemplates } from './listedkit.defautData';

const service = new DbService('listedkits', { schema });


const createListedKit = async (listedKit) => {
  const response = await service.create(listedKit);

  if (response.isBadRequest) {
    uiNotificationService.showError('Error happened. Please, refresh a page or try get back later.');
    return null;
  }

  return response.data[0];
};

const findDefaultListedKits = async (companyId, type, name) => {
  // const matchQuery = { company_id: companyId };
  // if (type) {
  //   matchQuery.type = type;
  // }

  // if (name) {
  //   matchQuery.name = name;
  // }

  // const request = service
  //   .select()
  //   .match(matchQuery)
  //   .is('deal_id', null);

  // if (name === null) {
  //   request.is('name', null);
  // }

  // let response = await request;

  const response = await service.selectByKey({
    selectKey: 'findDefaultListedKits',
    params: {
      companyId,
      type,
      name,
    },
  });

  response = service.processResponse(response);

  return response.data;
};

const getListedKitByMilestoneId = async (milestoneId) => {
  // let response = await service
  //   .select()
  //   .contains('milestone_ids', [milestoneId]);

  const response = await service.selectByKey({
    selectKey: 'getListedKitByMilestoneId',
    params: {
      milestoneId,
    },
  });

  response = service.processResponse(response);

  // As a rule data.length cannot be more than 1.
  return response.data.length > 0 ? response.data[0] : null;
};

const updateListedKit = async (listedKitData) => {
  const response = await service.updateOne({ id: listedKitData.id }, listedKitData);

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

const getListedKitByTypeAndDealId = async ({ dealId, type }) => {
  const data = await service.find({
    deal_id: dealId,
    type,
  });

  return data?.[0] || null;
};

const removeListedKit = async (id) => {
  const response = await service.remove({ id });

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

const isListedKitExists = async ({ name }) => {
  // let response = await service
  //   .select('*', { head: true, count: 'exact' })
  //   .match({
  //     company_id: companyId,
  //     name: name,
  //   })
  //   .is('deal_id', null);

  const response = await service.selectByKey({
    selectKey: 'isListedKitExists',
    params: {
      name,
    },
  });

  response = service.processResponse(response);

  return !!response?.count;
};

export default Object.assign(service, {
  createListedKit,
  findDefaultListedKits,
  updateListedKit,
  getDefaultKitTemplates,
  getListedKitByTypeAndDealId,
  getListedKitByMilestoneId,
  removeListedKit,
  isListedKitExists,
});
